import './DashBoard.css';
import '../GlobalPages.css';
import { HeadersRoutes, INavMenuRoute } from '../../components/header/HeaderOptions';
import { useEffect, useRef, useState } from 'react';
import Loader, { LoaderDialog } from '../../components/loader/Loader';
import { ILineChartData } from '../../interfaces/type1/ILineChartData';
import { MessageDialog } from '../../components/messagebox/MessageBox';
import { IQueryParams, DateRange } from '../../interfaces/type1/IQueryParams';
import DataFactory from '../../services/type1/DataFactory';
import DashCard, { CardType } from './cards/DashCard';
import DashLineChart from './charts/DashLineChart';
import DashTable from './table/DashTable';
import { Select } from '../../components/select/Select';
import DashGroupedBarChart from './charts/DashGroupedBarChart';
import StringUtils from '../../utils/StringUtils';
import { CurrentUser } from '../../components/login/CurrentUser';
import { IDateEnumDTO } from '../../components/search/bydata/IDateEnumDTO';
import { API } from '../../services/api/API';
import DateUtils from '../../utils/DateUtils';
import Cache from '../../components/search/Cache';
import EmptyPage from '../empty/EmptyPage';


interface IDataCard {
    Data: ILineChartData,
    Key: INavMenuRoute
}

export default function DashBoard() {


    let [options, setOptions] = useState<IDateEnumDTO[]>([]);

    let [dados, setDados] = useState<IDataCard[]>([]);

    const cacheAPI = useRef<IDateEnumDTO[]>([]);
    let [useCache, setUseCache] = useState(true);


    let [searchParams, setSearchParams] = useState<IQueryParams>({
        DateRange: DateRange.CURRENT_WEEK,
        Start: new Date(),
        End: new Date(),
        GraphicId: "",
        GraphicType: 't1'
    });

    const [valor, setValor] = useState<string | number>(DateRange.CURRENT_WEEK);

    const relatoriosUsados: string[] =
        [
            "/v1/recursos",
            "/v1/atos_praticados",
            "/v1/selos_por_dia",
            "/v1/os_hora",
            "/v1/desempenho_serventia",
            "/v1/atos_gratuitos"
        ]


    useEffect(() => {


        if (!CurrentUser.User)
            return;

        console.log('', CurrentUser.User);

        (async () => {

            let optionsJsonArray: IDateEnumDTO[];


            let delayTask = (ms: number) => new Promise<void>((r, e) => setTimeout(() => r(), ms));           

             //remover apos o Google corrigir o problema do progress bar indevido no PWA
            await delayTask(500);
            
            LoaderDialog.Show(
                {
                    Title: "Aguarde",
                    Message: "Consultando dados..."
                });


            if (!cacheAPI.current.Any()) {

                let getOptionsResponse: Response | undefined;
                try {
                    getOptionsResponse = await API.RequestAsync('/data/get-dates-enums', CurrentUser.Token?.Token ?? "", 'GET');

                    if (!getOptionsResponse.ok) {
                        MessageDialog.Toast("Erro ao carregar dados", await getOptionsResponse.text());
                        return;
                    }
                }
                catch {
                    MessageDialog.Toast("Erro ao carregar dados", "Não foi possivel carregar as possibilidades de busca da API");
                    return;
                }

                optionsJsonArray = await getOptionsResponse.json() as IDateEnumDTO[];
            } else {
                optionsJsonArray = cacheAPI.current!;
            }

            setOptions(optionsJsonArray);


            let data: ILineChartData | undefined;


            let cache = Cache.GetCache();



            if (useCache && !!cache && cache.DateRange) {
                let cachedOption = optionsJsonArray.Where(s => s.DateRange == cache!.DateRange &&
                    (
                        s.DateRange != DateRange.LAST_WEEK && s.DateRange != DateRange.LAST_MONTH && s.DateRange != DateRange.UNDEFINED
                    )).FirstOrDefault();
                if (cachedOption) {
                    searchData(cachedOption?.DateRange!)
                    setValor(cachedOption.DateRange);
                    setUseCache(false);
                    return;
                }


                setUseCache(false);


            }

            try {

                dados = [];

                for (let chart of HeadersRoutes.GetRoutes()) {


                    if (!relatoriosUsados.Any(s => s == chart.URL))
                        continue;

                    searchParams.GraphicId = chart.URL;
                    searchParams.Start = DateUtils.CastStringToDate(optionsJsonArray.First(s => s.DateRange == searchParams.DateRange)!.Start.toString());
                    searchParams.End = DateUtils.CastStringToDate(optionsJsonArray.First(s => s.DateRange == searchParams.DateRange)!.End.toString());

                    await delayTask(500);

                    data = await DataFactory.GetRelatorioAsync(searchParams);

                    Cache.SetCache({
                        Start: optionsJsonArray.FirstOrDefault(s => s.DateRange == searchParams.DateRange)?.Start?.toString() ?? new Date().toString(),
                        End: optionsJsonArray.FirstOrDefault(s => s.DateRange == searchParams.DateRange)?.End?.toString() ?? new Date().toString(), DateRange: searchParams.DateRange
                    });


                    if (data)
                        dados.Add({
                            Data: data!,
                            Key: chart
                        });
                }


                LoaderDialog.Close();
                setDados(dados);


            } catch (e) {
                console.log(e)
                LoaderDialog.Close();
                let errorMessage = (e as Error).message;
                MessageDialog.Toast("Erro ao obter dados", errorMessage ? errorMessage : "Não foi possivel obter uma dados do servidor");
            }

        })();

    }, [searchParams]);





    const searchData = (range: DateRange) => {

        setSearchParams(p => {

            Cache.SetCache({
                Start: options.FirstOrDefault(s => s.DateRange == range)?.Start?.toString() ?? new Date().toString(),
                End: options.FirstOrDefault(s => s.DateRange == range)?.End?.toString() ?? new Date().toString(), DateRange: range
            });


            return {
                ...p,
                DateRange: range,
                Start: DateUtils.CastStringToDate(options.FirstOrDefault(s => s.DateRange == range)?.Start?.toString() ?? new Date().toString()) ?? new Date(),
                End: DateUtils.CastStringToDate(options.FirstOrDefault(s => s.DateRange == range)?.End?.toString() ?? new Date().toString()) ?? new Date(),
            };
        })

        setValor(range);
    }


    if (!dados || !dados.Any())
        return (

            <>
                <Loader />
                <EmptyPage />
            </>

        );


    return (
        <>
            <Loader />

            <div className="PageComponent DashComponent">


                <div>

                    <div>
                        <div className="SelectContainer">
                            <Select
                                options={[
                                    { label: "Hoje", value: DateRange.TODAY },
                                    { label: "Ontem", value: DateRange.YESTERDAY },
                                    { label: "Essa semana", value: DateRange.CURRENT_WEEK },
                                    { label: "Esse mês", value: DateRange.CURRENT_MONTH }
                                ]}
                                value={valor}
                                onChange={(v) => searchData(v as DateRange)}
                                placeholder="Selecione um período..."
                            />
                        </div>
                    </div>



                    <div className='RowCardsComponent'>


                        {
                            dados.Any(s => s.Key.URL == '/v1/recursos' && s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/recursos',
                                IconClass: dados.First(s => s.Key.URL == '/v1/recursos').Key.ImageClass,
                                Title: "Entradas",
                                SubTitle: (() => {

                                    let data = dados.First(s => s.Key.URL == '/v1/recursos').Data.DataSets.Data;

                                    let totalItens = data.Where(s => s.ExtraInfo2 == 'ITEM_OS').Sum(s => Number.parseInt(s.ExtraInfo));
                                    let totalLancamentos = data.Where(s => s.ExtraInfo2 == 'MANUAL').Sum(s => Number.parseInt(s.ExtraInfo));

                                    let itensString = totalItens == 1 ? `${totalItens} item` : `${StringUtils.FormatNumber(totalItens.toString())} itens`;
                                    let lancamentosString = totalLancamentos == 1 ? `${totalLancamentos} lançamento` : `${StringUtils.FormatNumber(totalLancamentos.toString())} lançamentos`;

                                    return `Soma de valores de ${itensString} e ${lancamentosString}`
                                })(),
                                Value: StringUtils.MonetaryFormat(dados.First(s => s.Key.URL == '/v1/recursos').Data.DataSets.Data.Sum(s => s.Total).toFixed(2))
                            }} />
                        }

                        {
                            dados.Any(s => s.Key.URL == '/v1/recursos' && !s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/recursos',
                                IconClass: "nav-icon pi pi-filter-slash",
                                Title: "Entradas",
                                SubTitle: "Sem informações",
                                Value: "R$ 0,00"
                            }} />
                        }



                        {
                            dados.Any(s => s.Key.URL == '/v1/atos_praticados' && s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/atos_praticados',
                                IconClass: dados.First(s => s.Key.URL == '/v1/atos_praticados').Key.ImageClass,
                                Title: "Atos Praticados",
                                SubTitle: `Total: ${StringUtils.MonetaryFormat(dados.First(s => s.Key.URL == '/v1/atos_praticados').Data.DataSets.Data.Sum(s => s.Total).toFixed(2))}`,
                                Value: `${StringUtils.FormatNumber(dados.First(s => s.Key.URL == '/v1/atos_praticados').Data.DataSets.Data.Sum(s => s.Quantity).toString())}`
                            }} />
                        }
                        {
                            dados.Any(s => s.Key.URL == '/v1/atos_praticados' && !s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/atos_praticados',
                                IconClass: "nav-icon pi pi-filter-slash",
                                Title: "Atos Praticados",
                                SubTitle: "Sem informações",
                                Value: "0"
                            }} />
                        }




                        {
                            dados.Any(s => s.Key.URL == '/v1/selos_por_dia' && s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/selos_por_dia',
                                IconClass: dados.First(s => s.Key.URL == '/v1/selos_por_dia').Key.ImageClass,
                                Title: "Selos",
                                SubTitle: `${(() => {

                                    let total = dados.First(s => s.Key.URL == '/v1/selos_por_dia').Data.DataSets.Data.Where(s => s.ExtraInfo == 'Utilizados').Sum(s => s.Total);
                                    let enviados = dados.First(s => s.Key.URL == '/v1/selos_por_dia').Data.DataSets.Data.Where(s => s.ExtraInfo == 'Enviados').Sum(s => s.Total);
                                    let p = (enviados / total) * 100
                                    return `${Math.trunc(p)}% enviados`;

                                })()}`,
                                Value: StringUtils.FormatNumber(dados.First(s => s.Key.URL == '/v1/selos_por_dia').Data.DataSets.Data.Where(s => s.ExtraInfo == 'Utilizados').Sum(s => s.Total).toString())
                            }} />
                        }
                        {
                            dados.Any(s => s.Key.URL == '/v1/selos_por_dia' && !s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/selos_por_dia',
                                IconClass: "nav-icon pi pi-filter-slash",
                                Title: "Selos",
                                SubTitle: "Sem informações",
                                Value: "0"
                            }} />
                        }




                        {
                            dados.Any(s => s.Key.URL == '/v1/os_hora' && s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/os_hora',
                                IconClass: dados.First(s => s.Key.URL == '/v1/os_hora').Key.ImageClass,
                                Title: 'Média de OSs por Dia',
                                SubTitle: `Horário de maior movimento: ${dados.First(s => s.Key.URL == '/v1/os_hora').Data.DataSets.Data.OrderByDescending(s => s.Total)[0].Group}`,
                                Value: dados.First(s => s.Key.URL == '/v1/os_hora').Data.DataSets.Data.Sum(s => s.Total).toString()
                            }} />
                        }
                        {
                            dados.Any(s => s.Key.URL == '/v1/os_hora' && !s.Data.DataSets.Data.Any()) &&
                            <DashCard {...{
                                Url: '/v1/os_hora',
                                IconClass: "nav-icon pi pi-filter-slash",
                                Title: "Média de OSs por Dia",
                                SubTitle: "Sem informações",
                                Value: "0"
                            }} />
                        }




                    </div>





                    <div className='Row3SlotsComponent'>

                        {
                            dados.Any(s => s.Key.URL == '/v1/os_hora') && dados.First(s => s.Key.URL == "/v1/os_hora").Data.DataSets.Data.Count() >= 3 &&
                            <>

                                <div className="dashchart" style={{ width: '100%' }}>
                                    <h1>Movimento na Serventia</h1>
                                    <DashLineChart Data={dados.First(s => s.Key.URL == '/v1/os_hora').Data} />
                                </div>

                            </>
                        }
                        {
                            dados.Any(s => s.Key.URL == '/v1/os_hora') && dados.First(s => s.Key.URL == "/v1/os_hora").Data.DataSets.Data.Count() < 3 &&
                            <>

                                <div className="dashchart" style={{ width: '100%' }}>
                                    <h1>Movimento na Serventia</h1>
                                    <DashGroupedBarChart Data={dados.First(s => s.Key.URL == '/v1/os_hora').Data} />
                                </div>

                            </>
                        }
                        {
                            dados.Any(s => s.Key.URL == '/v1/selos_por_dia') &&
                            <>

                                <div className="dashchart" style={{ width: '100%' }}>
                                    <h1>Utilização de Selos</h1>
                                    <DashGroupedBarChart Data={{
                                        ...dados.First(s => s.Key.URL == '/v1/selos_por_dia').Data, YTickFormatter: y => {


                                            try {
                                                if (Math.trunc(y) != y) {
                                                    if (y > dados.First(s => s.Key.URL == '/v1/selos_por_dia').Data.DataSets.Data.Max(v => v.Total))
                                                        y = Math.trunc(y) + 1;
                                                    else
                                                        return '';
                                                }

                                            } catch { }

                                            return `${y}`
                                        }
                                    }} />
                                </div>

                            </>
                        }

                        {
                            dados.Any(s => s.Key.URL == '/v1/desempenho_serventia') &&
                            <>

                                <div className="dashchart" style={{ width: '100%' }}>
                                    <h1>Entradas e Saídas</h1>
                                    <DashGroupedBarChart
                                        Data={{ ...dados.First(s => s.Key.URL == '/v1/desempenho_serventia').Data, Horizontal: true }} />
                                </div>

                            </>
                        }

                    </div>

                    <div className='Row1SlotsComponent'>


                        {

                            dados.Any(s => s.Key.URL == '/v1/desempenho_serventia') &&

                            <div className="dashchart" style={{ width: '100%' }}>
                                <h1>Desempenho da Serventia</h1>
                                <DashTable Data={dados.First(s => s.Key.URL == '/v1/desempenho_serventia').Data.TableDataSet!}></DashTable>
                            </div>
                        }





                    </div>



                    <div className='Row2SlotsComponent'>


                        {

                            dados.Any(s => s.Key.URL == '/v1/atos_praticados') &&

                            <div className="dashchart" style={{ width: '100%' }}>
                                <h1>Atos Mais Praticados</h1>
                                <DashTable Data={{
                                    Columns: dados.First(s => s.Key.URL == '/v1/atos_praticados').Data.TableDataSet!.Columns,
                                    ColumnsAlingments: dados.First(s => s.Key.URL == '/v1/atos_praticados').Data.TableDataSet!.ColumnsAlingments,
                                    Totals: undefined,
                                    Rows: dados.First(s => s.Key.URL == '/v1/atos_praticados').Data.TableDataSet!.Rows.Take(5)
                                }}></DashTable>
                            </div>
                        }

                        {

                            dados.Any(s => s.Key.URL == '/v1/atos_gratuitos') &&

                            <div className="dashchart" style={{ width: '100%' }}>
                                <h1>Atos Gratuitos Mais Praticados</h1>
                                <DashTable Data={{
                                    Columns: dados.First(s => s.Key.URL == '/v1/atos_gratuitos').Data.TableDataSet!.Columns,
                                    ColumnsAlingments: dados.First(s => s.Key.URL == '/v1/atos_gratuitos').Data.TableDataSet!.ColumnsAlingments,
                                    Totals: undefined,
                                    Rows: dados.First(s => s.Key.URL == '/v1/atos_gratuitos').Data.TableDataSet!.Rows.Take(5)
                                }}></DashTable>
                            </div>
                        }

                    </div>

                </div>
            </div>
        </>
    )
}